import React, { useState } from 'react';
import { Button, Typography } from 'antd';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { useRetainIQCallLogTabs } from './RetainIQCallLogTabsContext';

export const RetainIQCallLogTabBar: React.FC = () => {
  const { tabs, activeTabId, addTab, removeTab, switchTab } = useRetainIQCallLogTabs();
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-end',
        gap: 4,
        flexWrap: 'wrap',
        marginBottom: 12,
        borderBottom: '1px solid #f0f0f0',
        paddingBottom: 0,
      }}
    >
      {tabs.map((tab) => {
        const isActive = tab.id === activeTabId;
        const isHovered = tab.id === hoveredId;
        return (
          <div
            key={tab.id}
            onClick={() => switchTab(tab.id)}
            onMouseEnter={() => setHoveredId(tab.id)}
            onMouseLeave={() => setHoveredId(null)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              padding: '8px 14px',
              cursor: 'pointer',
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              border: isActive ? '1px solid #e8e8e8' : '1px solid #eee',
              borderBottom: isActive ? '1px solid #fff' : '1px solid #eee',
              backgroundColor: isActive ? '#fff' : '#fafafa',
              maxWidth: 220,
              marginBottom: -1,
              position: 'relative',
              zIndex: isActive ? 2 : 1,
            }}
          >
            <Typography.Text
              ellipsis
              title={tab.label}
              style={{ flex: 1, minWidth: 0, fontWeight: isActive ? 600 : 400, fontSize: 13 }}
            >
              {tab.label}
            </Typography.Text>
            <span
              onClick={(e) => {
                e.stopPropagation();
                removeTab(tab.id);
              }}
              style={{
                display: 'flex',
                opacity: isHovered || isActive ? 1 : 0,
                transition: 'opacity 0.15s',
              }}
            >
              <CloseOutlined style={{ fontSize: 11, color: '#888' }} />
            </span>
          </div>
        );
      })}
      <Button type="dashed" size="small" icon={<PlusOutlined />} onClick={addTab} style={{ marginBottom: 4 }}>
        New tab
      </Button>
    </div>
  );
};
